/**
 * PartiesActionCreator - Dweb
 */

import * as constants from "../constants";
import { getVehicleNumberValues, getAvatarStringFromName, getVehicleNumberValuesDWeb } from "./utils/utils"
import * as logger from '../../logger';


export const getMonthlyBalancesParty = (partyId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: `/customer/${partyId}/monthly-balance`,
        success: (response) => populateMonthlyBalances(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const getSinglePartyPaymentDetails = (partyId, paymentId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: `/customer/${partyId}/payment/` + paymentId,
        success: (response) => populateSinglePartyPaymentDetails(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const getPartyTransactHistory = (partyId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: `/transaction-history/customer/` + partyId,
        success: (response) => populatePartyTransactHistory(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
})

const populatePartyTransactHistory = (response) => {
    let payloadData = {};
    if (response.status && response.status.code && response.status.code == 200) {
        payloadData = response.response
    }
    return { type: constants.GET_PARTY_TRANSACT_HISTORY, payload: payloadData };
}
export const getPartyDetails = (partyId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: `/customer/` + partyId,
        success: (response) => populatePartyDetails(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
})

const populatePartyDetails = (response) => {
    let payloadData = {};
    if (response.status && response.status.code && response.status.code == 200) {
        payloadData = response.response
    }
    return { type: constants.GET_PARTY_DETAILS, payload: payloadData };
}

const populateSinglePartyPaymentDetails = (response) => {
    var payloadData = {}
    if (response.status && response.status.code && response.status.code == 200) {
        payloadData = response.response
    }
    return { type: constants.GET_SINGLE_PARTY_PAYMENT, payload: payloadData };
}
export const getSinglePartyCollectionReminder = (partyId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: `/customer/${partyId}/reminder`,
        success: (response) => populateCollectionReminder(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
const populateCollectionReminder = (response) => {
    var payloadData = null
    if (response.status && response.status.code && response.status.code == 200) {
        payloadData = response.response ? response.response : null;
        if (payloadData && payloadData.reminderDate) {
            payloadData.reminder = new Date(payloadData.reminderDate * 1000);
        }
    }
    return { type: constants.GET_COLLECTION_REMINDER, payload: payloadData };
}
export const updatePartyReminder = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "PUT",
        url: `/customer/reminder`,
        data,
        success: (response) => { return { type: null, payload: null } },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const addPartyReminder = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: `/customer/reminder`,
        data,
        success: (response) => { return { type: null, payload: null } },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const getPartyCompanyDetails = (partyId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: `/customer/${partyId}/details/company`,
        success: (response) => populateSinglePartyCompanyDetails(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const getPartySettings = (partyId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: `/customer/${partyId}/settings`,
        success: (response) => populateSinglePartySettings(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const updatePartySettings = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "PUT",
        url: `/customer/settings`,
        data,
        success: (response) => { return { type: null, payload: null } },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
const populateSinglePartyCompanyDetails = (response) => {
    var payloadData = {}
    if (response.status && response.status.code && response.status.code == 200) {
        payloadData = response.response
    }
    return { type: constants.GET_PARTY_COMPANY_DETAILS, payload: payloadData };
}
const populateSinglePartySettings = (response) => {
    var payloadData = {}
    if (response.status && response.status.code && response.status.code == 200) {
        payloadData = response.response
        let index = 0;
        if (payloadData.reminderDuration && payloadData.reminderConfig && Array.isArray(payloadData.reminderConfig)) {
            for (const key in payloadData.reminderConfig) {
                if (Object.hasOwnProperty.call(payloadData.reminderConfig, key)) {
                    const element = payloadData.reminderConfig[key];
                    if (element && element.value && element.value.count && element.value.count == payloadData.reminderDuration) {
                        index = key;
                    }
                }
            }
        }
        payloadData.reminderIndex = Number(index);
    }
    return { type: constants.GET_PARTY_SETTINGS, payload: payloadData };
}
export const addSinglePartyCompanyDetails = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: `/customer/details/company`,
        data,
        success: (response) => { return { type: null, payload: null } },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const updateSinglePartyCompanyDetails = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "PUT",
        url: `/customer/details/company`,
        data,
        success: (response) => { return { type: null, payload: null } },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const updatePaymentsTabFilter = (data) => {
    return { type: constants.UPDATE_PARTY_PAYMENT_TAB_FILTER, payload: data };
}
export const updateTripsTabFilter = (data) => {
    return { type: constants.UPDATE_PARTY_TRIPS_TAB_FILTER, payload: data };
}
export const getTripSparkLine = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: `/customer/get_sparkline`,
        data,
        success: (response) => populateTripSparkline(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const getSuggestionsTrips = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: `/customer/payment/suggestion`,
        data,
        success: (response) => populateSuggestionsTrips(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const getSuggestionsTripsForEdit = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: `/customer/payment/edit/suggestion`,
        data,
        success: (response) => populateSuggestionsTrips(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const addSinglePartyPayment = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: `/customer/payment`,
        data,
        success: (response) => { return { type: null, payload: null } },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const updateSinglePartyPayment = (data, paymentId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "PUT",
        url: `/customer/payment/` + paymentId,
        data,
        success: (response) => { return { type: null, payload: null } },
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const updatePartyTab = (tab) => {
    return { type: 'SINGLE_PARTY_PAYMENT', payload: tab }
};

const populateSuggestionsTrips = (response) => {
    let payloadData = []
    if (response.status && response.status.code && response.status.code == 200) {
        let data = response.response;
        for (const key in data) {
            if (Object.hasOwnProperty.call(data, key)) {
                const element = data[key];
                if(element.balanceAmount){
                    element.tripBalance=element.balanceAmount;
                    element.tripId = 'openingBalance';
                }else{
                    element.tripId = String(element.tripId)
                }
                payloadData.push(element)
            }
        }
    } else {
    }
    return { type: constants.GET_PARTY_SUGGESTIONS_TRIPS, payload: payloadData };
}
export const getPartyPayments = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: `/customer/transaction-log`,
        data,
        success: (response) => populateTripPayments(response,data && data.merge ? data.merge : false),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const editParty = (id, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "PUT",
        url: `/customermapping/${id}`,
        data,
        success: (response) => handleUnwantedData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const editPartyOpeningBalance = (id, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "PUT",
        url: `/customer/expense/${id}`,
        data,
        success: (response) => handleUnwantedData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const deletePartyOpeningBalance = (id, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "DELETE",
        url: `/customer/expense/${id}`,
        data,
        success: (response) => handleUnwantedData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});
export const addPartyOpeningBalance = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: `/customer/expense`,
        data,
        success: (response) => handleUnwantedData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const editShop = (id, data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "PUT",
        url: `/khata/shop/${id}`,
        data,
        success: (response) => handleUnwantedData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const deleteParty = (id, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "DELETE",
        url: `/customermapping/${id}`,
        success: (response) => handleUnwantedData(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

const populateMonthlyBalances = (response) => {
    var payloadData = { totalPartyBalances: 0, monthlyBalances: [] }
    if (response.status && response.status.code && response.status.code == 200) {
        let montlyResponse = response.response
        if (montlyResponse && montlyResponse.openingBalance) {
            let bal = montlyResponse.openingBalance;
            let data = {
                ...bal,
                name:bal.month,
                totalPayment:0,
                balance:bal.remainingAmount,
                openingBalance:true
            }
            if(bal && bal.payments){
                for (const key in bal.payments) {
                    if (Object.hasOwnProperty.call(bal.payments, key)) {
                        const element = bal.payments[key];
                        if (element.amount && Number(element.amount)>0) {
                            data.totalPayment += Number(element.amount);
                        }
                    }
                }
            }
            payloadData.monthlyBalances.push(data)
        }
        if (montlyResponse && montlyResponse.monthlyBalance) {
            payloadData.monthlyBalances = [... montlyResponse.monthlyBalance,...payloadData.monthlyBalances];
            for (const key in montlyResponse.monthlyBalance) {
                if (Object.hasOwnProperty.call(montlyResponse.monthlyBalance, key)) {
                    const element = montlyResponse.monthlyBalance[key];
                    if (element.balance) {
                        payloadData.totalPartyBalances += Number(element.balance);
                    }
                }
            }
        }
    } else {
    }
    return { type: constants.GET_PARTY_MONTHLY_BALANCES, payload: payloadData };
}
const populateTripSparkline = (response) => {
    let payloadData = { totalBalance: 0, totalPaymentReceived: 0, totalRevenue: 0 }
    if (response.status && response.status.code && response.status.code == 200) {
        let sparLineResponse = response.response
        payloadData = { ...sparLineResponse };
    } else {
    }
    return { type: constants.GET_PARTY_TRIP_SPARKLINE, payload: payloadData };
}
const populateTripPayments = (response,merge) => {
    let payloadData = []
    if (response.status && response.status.code && response.status.code == 200) {
        let paymentsResponse = response.response
        if (paymentsResponse.transactionLog) {
            for (const key in paymentsResponse.transactionLog) {
                if (Object.hasOwnProperty.call(paymentsResponse.transactionLog, key)) {
                    const element = paymentsResponse.transactionLog[key];
                    if (element.lineItems) {
                        for (const itemKey in element.lineItems) {
                            if (Object.hasOwnProperty.call(element.lineItems, itemKey)) {
                                const lineItem = element.lineItems[itemKey];
                                let transDate = lineItem && lineItem.transactionParams && lineItem.transactionParams[0] ? lineItem.transactionParams[0] : null;
                                let vehicleNumber = ''
                                lineItem.tripDetails = {
                                }
                                if (lineItem.tripId) {
                                    vehicleNumber = lineItem && lineItem.transactionParams && lineItem.transactionParams[1] ? lineItem.transactionParams[1] : ''
                                    let vehicleNumArrayDwebValue = getVehicleNumberValuesDWeb(vehicleNumber);
                                    lineItem.tripDetails.vehicleNumArrayDweb = vehicleNumArrayDwebValue;
                                    lineItem.tripDetails.vehicle = true;
                                    lineItem.vehicleNumber = vehicleNumber
                                } else {
                                    let trips = lineItem && lineItem.transactionParams && lineItem.transactionParams[1] ? lineItem.transactionParams[1] : '';
                                    let transactId = lineItem && lineItem.transactionParams && lineItem.transactionParams[2] ? lineItem.transactionParams[2] : '';
                                    lineItem.tripDetails.vehicle = false;
                                    lineItem.tripDetails.trips = trips;
                                    lineItem.tripDetails.transactioNumber = transactId;
                                }
                                let paymentData = {
                                    ...lineItem,
                                    date: transDate,
                                    sorDate: new Date(transDate)
                                }
                                payloadData.push(paymentData);
                            }
                        }
                    }
                }
            }
        }
    } else {
    }
    return { type: constants.GET_PARTY_PAYMENTS, payload: {
        payments:payloadData,
        merge:merge,
        maxPage:response && response.response && response.response.maxPage?response.response.maxPage:null
    } };
}

const handleUnwantedData = (response) => {
    return { type: null, payload: null }
}

export const fetchPartyIncomeReport = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: "/v2/user-org/reports/income/party",
        data,
        success: (response) => processPartyIncomeReport(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError
    }
});

const processPartyIncomeReport = (response) => {
    let payloadData = response.response;
    return { type: constants.GET_PARTY_INCOME_REPORT, payload: payloadData }
}

export const getPartyIncomeExcel = (monthYear, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: "/excel/party/income?monthYear=" + monthYear,
        success: (response) => processPartyIncomeExcel(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError
    }
});

const processPartyIncomeExcel = (response) => {
    let payloadData = response.response;
    return { type: constants.PARTY_INCOME_EXCEL, payload: payloadData }
}

export const getMonthlyBalancesPartyForReports = (partyId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "GET",
        url: `/customer/${partyId}/monthly-balance`,
        success: (response) => populateMonthlyBalancesForReports(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

const populateMonthlyBalancesForReports = (response) => {
    let payloadData = response.response;
    return { type: constants.GET_PARTY_MONTHLY_BALANCES_FOR_REPORTS, payload: payloadData }
}

export const deletePartyPayment = (paymentId, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "DELETE",
        url: "/customer/payment/" + paymentId,
        success: (response) => processNoStateUpdate(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
});

export const editPartyDetailsInvoice = (data, onSuccess, onError) => ({
    type: constants.API,
    payload: {
        method: "POST",
        url: `/customer/details/company`,
        data: data,
        success: (response) => processNoStateUpdate(response),
        postProcessSuccess: onSuccess,
        postProcessError: onError,
    }
})

const processNoStateUpdate = () => {
    return { type: null, payload: null }
}